import { initializeBackend, createBrowserStorage } from "./backend/client";
export { auth, db, storage, rtdb, functions } from "./backend/client";
export const app=initializeBackend({storage:createBrowserStorage("local")});
